import { useViewportStore } from '@/store/useViewportStore';
import styled from 'styled-components';
import DefaultProductSkeleton from './DefaultProductSkeleton';

type Props = {
  isSpecialSection?: boolean;
  number?: number;
  customGridColumnNum?: string;
};

const FeaturedSectionSkeleton = ({ isSpecialSection = false, number = 4 }: Props) => {
  const isMobile = useViewportStore((store) => store.isMobile);
  const cardArray = Array.from({ length: number }, (_, index) => {
    return index + 1;
  });
  return (
    <Section isMobile={isMobile} isSpecial={isSpecialSection}>
      {cardArray.map((item) => (
        <DefaultProductSkeleton isSpecialSection={isSpecialSection} key={item} />
      ))}
    </Section>
  );
};

export default FeaturedSectionSkeleton;

const Section = styled.section<{ isMobile: boolean; isSpecial?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ isMobile, isSpecial }) =>
    isMobile ? (isSpecial ? 'repeat(1,1fr)' : 'repeat(2,1fr)') : 'repeat(4,1fr)'};
  gap: 16px;
  margin-bottom: 60px;
`;
